import { useState, useEffect } from 'react';
import { apiClient } from '../../components/api/ApiClient';

const ProfileDetails = () => {
    const [profileData, setProfileData] = useState({
        username: '',
        password: '********',
        referrerUsername: '',
        referralLink: '',
        businessType: 'حقیقی',
        businessName: '',
        businessNameEn: '',
        naturalPersonName: '',
        naturalPersonLastName: '',
        economicCode: '',
        registrationNumber: '',
        province: '',
        city: '',
        address: '',
        phone: '',
        mobile: '',
        mobileVerificationCode: '',
        postalCode: '',
        landlinePhone: ''
    });

    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [mobileVerified, setMobileVerified] = useState(false);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [verificationCodeSent, setVerificationCodeSent] = useState(false);

    useEffect(() => {
        fetchProfileData();
        fetchProvinces();
    }, []);

    useEffect(() => {
        if (profileData.province) {
            fetchCities(profileData.province);
        }
    }, [profileData.province]);

    const fetchProfileData = async () => {
        try {
            const response = await apiClient('/api/profile/details');
            setProfileData(prev => ({
                ...prev,
                ...response,
                password: '********'
            }));
            if (response.mobileVerified) {
                setMobileVerified(true);
            }
            if (response.referralLink) {
                setProfileData(prev => ({...prev, referralLink: response.referralLink}));
            }
        } catch (error) {
            console.error('Error fetching profile:', error);
        }
    };

    const fetchProvinces = async () => {
        try {
            const response = await apiClient('/api/location/provinces');
            setProvinces(response);
        } catch (error) {
            console.error('Error fetching provinces:', error);
        }
    };

    const fetchCities = async (provinceId) => {
        try {
            const response = await apiClient(`/api/location/cities/${provinceId}`);
            setCities(response);
        } catch (error) {
            console.error('Error fetching cities:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfileData(prev => ({ ...prev, [name]: value }));
    };

    const handleBusinessTypeChange = (type) => {
        setProfileData(prev => ({
            ...prev,
            businessType: type,
            businessName: type === 'حقوقی' ? prev.businessName : '',
            businessNameEn: type === 'حقوقی' ? prev.businessNameEn : '',
            naturalPersonName: type === 'حقیقی' ? prev.naturalPersonName : '',
            naturalPersonLastName: type === 'حقیقی' ? prev.naturalPersonLastName : ''
        }));
    };

    const sendVerificationCode = async () => {
        if (!profileData.mobile) {
            alert('لطفا شماره همراه را وارد کنید');
            return;
        }

        try {
            setLoading(true);
            await apiClient('/api/auth/send-verification-code', {
                method: 'POST',
                data: {
                    mobile: profileData.mobile
                }
            });
            setVerificationCodeSent(true);
            alert('کد تایید ارسال شد');
        } catch (error) {
            alert('خطا در ارسال کد تایید');
        } finally {
            setLoading(false);
        }
    };

    const verifyMobile = async () => {
        if (!profileData.mobileVerificationCode) {
            alert('لطفا کد تایید را وارد کنید');
            return;
        }

        try {
            setLoading(true);
            await apiClient('/api/auth/verify-mobile', {
                method: 'POST',
                data: {
                    mobile: profileData.mobile,
                    code: profileData.mobileVerificationCode
                }
            });
            setMobileVerified(true);
            alert('شماره همراه با موفقیت تایید شد');
        } catch (error) {
            alert('کد تایید نامعتبر است');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!mobileVerified) {
            alert('لطفا ابتدا شماره همراه خود را تایید کنید');
            return;
        }

        try {
            setLoading(true);
            await apiClient('/api/profile/update', {
                method: 'PUT',
                data: profileData
            });
            alert('پروفایل با موفقیت بروزرسانی شد');
        } catch (error) {
            alert('خطا در بروزرسانی پروفایل');
        } finally {
            setLoading(false);
        }
    };

    const handlePasswordChange = async () => {
        try {
            setLoading(true);
            await apiClient('/api/auth/send-password-reset-code', {
                method: 'POST',
                data: {
                    mobile: profileData.mobile
                }
            });
            alert('کد تغییر رمز به تلفن صاحب بنگاه اقتصادی ارسال شد');
            setShowChangePassword(true);
        } catch (error) {
            alert('خطا در ارسال کد تغییر رمز');
        } finally {
            setLoading(false);
        }
    };

    const copyReferralLink = () => {
        if (profileData.referralLink) {
            navigator.clipboard.writeText(profileData.referralLink);
            alert('لینک معرفی کپی شد');
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">جزئیات حساب کاربری</h4>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">نام کاربری:</label>
                                        <div className="form-control bg-light">
                                            {profileData.username || 'نام کاربری نمایش داده می‌شود'}
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">رمز عبور:</label>
                                        <div className="input-group">
                                            <input
                                                type="password"
                                                className="form-control"
                                                value={profileData.password}
                                                readOnly
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary"
                                                onClick={handlePasswordChange}
                                            >
                                                <i className="feather-edit-2"></i> تغییر رمز
                                            </button>
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">نام کاربری معرف:</label>
                                        <div className="form-control bg-light">
                                            {profileData.referrerUsername || 'ندارد'}
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">لینک معرفی شما:</label>
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={profileData.referralLink || 'در حال تولید...'}
                                                readOnly
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-outline-success"
                                                onClick={copyReferralLink}
                                            >
                                                <i className="feather-copy"></i> کپی
                                            </button>
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">نوع شخصیت تجاری:</label>
                                        <div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="businessType"
                                                    id="natural"
                                                    value="حقیقی"
                                                    checked={profileData.businessType === 'حقیقی'}
                                                    onChange={() => handleBusinessTypeChange('حقیقی')}
                                                />
                                                <label className="form-check-label" htmlFor="natural">حقیقی</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="businessType"
                                                    id="legal"
                                                    value="حقوقی"
                                                    checked={profileData.businessType === 'حقوقی'}
                                                    onChange={() => handleBusinessTypeChange('حقوقی')}
                                                />
                                                <label className="form-check-label" htmlFor="legal">حقوقی</label>
                                            </div>
                                        </div>
                                    </div>

                                    {profileData.businessType === 'حقوقی' && (
                                        <>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">نام واحد تجاری:</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="businessName"
                                                    value={profileData.businessName}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">نام واحد تجاری (انگلیسی):</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="businessNameEn"
                                                    value={profileData.businessNameEn}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </>
                                    )}

                                    {profileData.businessType === 'حقیقی' && (
                                        <>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">نام شخص حقیقی:</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="naturalPersonName"
                                                    value={profileData.naturalPersonName}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">نام خانوادگی شخص حقیقی:</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="naturalPersonLastName"
                                                    value={profileData.naturalPersonLastName}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </>
                                    )}

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">کد اقتصادی:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="economicCode"
                                            value={profileData.economicCode}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">شماره ثبت:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="registrationNumber"
                                            value={profileData.registrationNumber}
                                            onChange={handleChange}
                                            required={profileData.businessType === 'حقوقی'}
                                            disabled={profileData.businessType !== 'حقوقی'}
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">شماره همراه صاحب بنگاه اقتصادی:</label>
                                        <div className="input-group">
                                            <input
                                                type="tel"
                                                className="form-control"
                                                name="mobile"
                                                value={profileData.mobile}
                                                onChange={handleChange}
                                                required
                                            />
                                            {!mobileVerified && (
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary"
                                                    onClick={sendVerificationCode}
                                                    disabled={loading || verificationCodeSent}
                                                >
                                                    <i className="feather-send"></i> ارسال کد
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    {verificationCodeSent && !mobileVerified && (
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">کد تایید:</label>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="mobileVerificationCode"
                                                    value={profileData.mobileVerificationCode}
                                                    onChange={handleChange}
                                                    placeholder="کد ارسال شده را وارد کنید"
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-success"
                                                    onClick={verifyMobile}
                                                    disabled={loading}
                                                >
                                                    <i className="feather-check"></i> تایید
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {mobileVerified && (
                                        <div className="col-md-6 mb-3">
                                            <div className="alert alert-success">
                                                <i className="feather-check-circle"></i> شماره همراه تایید شده است
                                            </div>
                                        </div>
                                    )}

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">استان:</label>
                                        <select
                                            className="form-select"
                                            name="province"
                                            value={profileData.province}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">انتخاب استان</option>
                                            {provinces.map(province => (
                                                <option key={province.id} value={province.id}>
                                                    {province.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">شهر:</label>
                                        <select
                                            className="form-select"
                                            name="city"
                                            value={profileData.city}
                                            onChange={handleChange}
                                            required
                                            disabled={!profileData.province}
                                        >
                                            <option value="">انتخاب شهر</option>
                                            {cities.map(city => (
                                                <option key={city.id} value={city.id}>
                                                    {city.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-12 mb-3">
                                        <label className="form-label">آدرس:</label>
                                        <textarea
                                            className="form-control"
                                            name="address"
                                            value={profileData.address}
                                            onChange={handleChange}
                                            rows="3"
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">کد پستی:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="postalCode"
                                            value={profileData.postalCode}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">تلفن ثابت:</label>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            name="landlinePhone"
                                            value={profileData.landlinePhone}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="col-12 mt-4">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading || !mobileVerified}
                                        >
                                            {loading ? (
                                                <>
                                                    <i className="feather-loader"></i> در حال ذخیره...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="feather-save"></i> ذخیره تغییرات
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileDetails;